import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card,
  Grid,
  CardContent,
  Avatar,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const CancellationReasonsCardPreview = ({
  className, cancellationReason, ...rest
}) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={9}>
            <Avatar
              className={classes.avatar}
              alt="cancellationReason"
              src="https://storage.googleapis.com/bucket-adomi-dev/images/Cancellation_reasons.jpg"
              variant="square"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

CancellationReasonsCardPreview.propTypes = {
  className: PropTypes.string,
  cancellationReason: PropTypes.object,
};

CancellationReasonsCardPreview.defaultProps = {
  className: '',
  cancellationReason: {},
};

export default CancellationReasonsCardPreview;
